import Navbar from '../components/cummon/Navbar';
import Hero from '../components/acceuil/Hero';
import StatsScroller from '../components/acceuil/Stats';
import Features from '../components/acceuil/Features';
import Sectors from '../components/acceuil/Sectors';
import Process from '../components/acceuil/Workflow';
import Pricing from '../components/acceuil/Pricing';
import Reviews from '../components/acceuil/Testimonials';
import CTA from '../components/acceuil/CTA';
import Performances from '../components/acceuil/performances';
import Footer from '../components/cummon/Footer';
import OffensiveServices from '../components/acceuil/services';
import Mission from '../components/acceuil/mission';
import Offers from '../components/acceuil/offres';
import TrustAndGuarantees from '../components/acceuil/confiance';
import Urgence from '../components/acceuil/agir';

function Acceuil() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Performances />
      <StatsScroller />
      <Mission />
      <Features />
      <Sectors />
      <OffensiveServices/>
      <Process />
      <Offers />
      <TrustAndGuarantees />
      <Urgence />
      <Reviews />
      <Pricing />
      
      <Footer />
      
    
    
    </div>
  );
}

export default Acceuil;